export const getShortenedGuidForDisplay = (guid: string, numberOfCharacters: number) => {
  return guid.substring(0, numberOfCharacters - 1);
};
